<template>
  <div class="sf-product-grid" :class="[`sf-product-grid--${gridVariant}`, columnsClass]">
    <StoreProductCard
      v-for="product in products"
      :key="product.id"
      :product="product"
      :variant="gridVariant"
      :thumb="thumb"
      @select="(p: any) => emit('select', p)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import StoreProductCard from './StoreProductCard.vue'
import { storefrontTemplate, storefrontColumnsMobile, ProductCardVariant } from '@/global/state/StorefrontState'

/* global defineProps, defineEmits, withDefaults */
const props = withDefaults(defineProps<{
  products: any[]
  variant?: ProductCardVariant
  thumb?: boolean
}>(), { variant: undefined, thumb: true })

const emit = defineEmits(['select'])

const gridVariant = computed<ProductCardVariant>(() => props.variant ?? storefrontTemplate.value)

/** Image-top cards only: rows (classic) and the printed menu (minimal) are naturally one column on mobile. */
const COLUMN_AWARE: ProductCardVariant[] = ['grid', 'showcase', 'dark']
const columnsClass = computed(() => {
  const columns = storefrontColumnsMobile.value
  if (columns === 'auto' || !COLUMN_AWARE.includes(gridVariant.value)) return ''
  return `sf-product-grid--cols-${columns}`
})
</script>
